// src/store/slices/profileSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "@/modules/shared/api/axios";
import { setLoading } from "@/modules/shared/store/uiSlice";

export const checkProfile = createAsyncThunk(
  'profile/checkProfile',
  async (_, { getState, dispatch, rejectWithValue }) => {
    const user = getState().auth.user;
    if (!user) return rejectWithValue('No user');

    dispatch(setLoading(true));
    try {
      const res = await api.get('/user');
      dispatch(setLoading(false));
      const userPayload = res?.data || {};
      const company = userPayload?.company || null;

      const normalized = company
        ? [
            {
              CompanyName: company.name_ar || company.name_en || user?.company_name || "",
              UnifiedNumber: company.unified_number || user?.unified_number || "",
              Phone_Number1: company.contact_phone || user?.phone || "",
              Email: company.contact_email || user?.email || "",
              ID: company.zoho_record_id || company.id,
            },
          ]
        : [];

      return { complete: !!company, records: normalized };
    } catch (e) {
      dispatch(setLoading(false));
      return rejectWithValue(e.response?.data || e.message);
    }
  }
);

const slice = createSlice({
  name: 'profile',
  initialState: { complete: false, checking: false, records: [], error: null, loaded: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkProfile.pending, (s) => { s.checking = true; s.error = null; })
      .addCase(checkProfile.fulfilled, (s, a) => {
        s.checking = false;
        s.complete = !!a.payload.complete;
        s.records = Array.isArray(a.payload.records) ? a.payload.records : [];
        s.loaded = true;
      })
      .addCase(checkProfile.rejected, (s, a) => {
        s.checking = false;
        s.error = a.payload || a.error.message;
        s.loaded = true;
      });
  }
});

export default slice.reducer;
